class NotifyMeBtn {
  constructor(parentPage, windowData, selectedVariant) {
    this.parentPage = parentPage;
    this.windowData = windowData;
    this.selectedVariant = selectedVariant;

    if (!(this.parentPage && this.windowData && this.selectedVariant)) {
      throw new Error('Could not create Notify Me Button');
    }
  }

  mount() {
    const btn = this._button();
    if (btn) {
      btn.addEventListener('click', () => {
        const state = this.selectedVariant.getState();
        this.parentPage.postMessage('notify-me-clicked', {
          productId: this.windowData.productId,
          ...state,
        });
      });
    }
  }

  onNewVariant(checkoutEnabled) {
    const btn = this._button();
    if (btn) {
      if (checkoutEnabled) {
        btn.disabled = false;
      } else {
        btn.disabled = true;
      }
    }
  }

  _button() {
    const btn = document.querySelector('#notify-me');
    return btn;
  }
}

export default NotifyMeBtn;
